import { InjectionToken } from '@angular/core';
import { onboardExpene500, onboardExpene200 } from './o-expenses.mock';
import { guestSummary200, guestSummary500 } from './guest-summary.mock';
import { landingPages500, LandingPages200 } from './landing-page.mock';
import { translation500, translation200 } from './translation.mock';

export const MOCKS = new InjectionToken('mocks');

export const mocks = {
	// Onboard Expense
	'oe-200': onboardExpene200(),
	'oe-500': onboardExpene500(),

	// Guest Summary
	'gs-500': guestSummary500(),
	'gs-200': guestSummary200(),

	// Landing pages
	'lp-500': landingPages500(),
	'lp-200': LandingPages200(),

	// Translation
	'tr-500': translation500(),
	'tr-200': translation200()
};
